import React from "react";

import { useEffectOnce } from "@/modules/common-hooks/useEffectOnce";

type Props<T> = {
  children: () => AsyncGenerator<React.ReactNode, T>;
  onResolve: (value: T) => void;
  onReject: (reason: unknown) => void;
};

export default function ModalAsyncGenerator<T>({
  children,
  onResolve,
  onReject,
}: Props<T>) {
  const [node, setNode] = React.useState<React.ReactNode>();

  const run = children
    ? async () => {
        try {
          const generator = children();
          while (true) {
            const iter = await generator.next();
            if (iter.done) {
              onResolve(iter.value);
              break;
            } else {
              setNode(iter.value);
            }
          }
        } catch (error) {
          onReject(error);
        }
      }
    : undefined;

  useEffectOnce(run ? () => void run() : undefined);

  return node;
}
